import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export const resetAppShellScroll = () => {
  const html = document.documentElement;
  const body = document.body;
  html.scrollTop = 0;
  body.scrollTop = 0;
  if ((window.scrollY || window.scrollX) && typeof window.scrollTo === "function") {
    window.scrollTo(0, 0);
  }
  const shell = document.querySelector(".App.appShellViewport");
  if (shell) {
    shell.scrollTop = 0;
    shell.scrollLeft = 0;
  }
};

/** If focus/hash scrolled an ancestor, pull the in-flow navbar back on screen. */
export const pinNavbarIntoView = () => {
  resetAppShellScroll();
  const root = document.getElementById("root");
  if (root?.style?.overflow) {
    root.style.removeProperty("overflow");
    root.style.removeProperty("width");
    root.style.removeProperty("height");
  }
  const header = document.getElementById("header_to_menu");
  if (!header || header.getBoundingClientRect().top >= 0) return;
  let parent = header.parentElement;
  while (parent && parent !== document.documentElement) {
    if (parent.scrollTop) parent.scrollTop = 0;
    if (parent.scrollLeft) parent.scrollLeft = 0;
    parent = parent.parentElement;
  }
  resetAppShellScroll();
};

const pinAfterLayout = () => {
  pinNavbarIntoView();
  let frames = 0;
  let rafId = 0;
  const tick = () => {
    pinNavbarIntoView();
    frames += 1;
    if (frames < 16) {
      rafId = window.requestAnimationFrame(tick);
    }
  };
  rafId = window.requestAnimationFrame(tick);
  return () => window.cancelAnimationFrame(rafId);
};

/**
 * Document/window must not be a scrollport. The navbar lives in the flex
 * column; only .appRouterOutlet (and page lists) scroll. Pin after focus
 * because Advisor composer focus can still move a leftover window offset.
 */
const AppShellScrollLock = () => {
  const { pathname, search } = useLocation();

  useLayoutEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    html.classList.add("viewport-locked");
    body.classList.add("viewport-locked");
    try {
      if (window.history && "scrollRestoration" in window.history) {
        window.history.scrollRestoration = "manual";
      }
    } catch (_) {}
    pinNavbarIntoView();

    const shell = document.querySelector(".App.appShellViewport");
    const pin = () => {
      pinNavbarIntoView();
    };

    if (shell) {
      shell.addEventListener("scroll", pin, { passive: true });
    }
    window.addEventListener("scroll", pin, { capture: true, passive: true });
    window.addEventListener("focusin", pin, true);
    window.addEventListener("pageshow", pin);
    return () => {
      html.classList.remove("viewport-locked");
      body.classList.remove("viewport-locked");
      if (shell) {
        shell.removeEventListener("scroll", pin);
      }
      window.removeEventListener("scroll", pin, true);
      window.removeEventListener("focusin", pin, true);
      window.removeEventListener("pageshow", pin);
    };
  }, []);

  useLayoutEffect(() => {
    return pinAfterLayout();
  }, [pathname, search]);

  return null;
};

export default AppShellScrollLock;
